<template>
  <div class="advertising-popup">
    <second-menu-link-content>
      <template v-slot:header>
        <span>广告弹窗</span>
      </template>
      <template v-slot:content>
        <div class="advertising-popup-main">
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="弹窗图片：" prop="images" :class="form.img ? 'visible' :''">
              <el-upload
                class="image"
                ref="upload"
                action="#"
                list-type="picture-card"
                :limit="1"
                :on-remove="onRemove"
                :before-upload="beforeUpload"
                :auto-upload="true"
                :file-list="fileList"
              >
                <el-button
                  v-loading="loading"
                  element-loading-text="上传中..."
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  slot="trigger"
                  size="small"
                  type="primary"
                >
                  <i class="add">＋</i>
                </el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="弹窗链接：">
              <el-input v-model="form.link" class="gray" placeholder="请输入链接"></el-input>
            </el-form-item>
            <el-form-item label="是否上架：">
              <el-radio-group v-model="form.state">
                <el-radio :label="true">开启</el-radio>
                <el-radio :label="false">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button class="btn-blue" @click="save">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import ImgUploader from 'models/img-upload.js';
import DBMarketing from 'models/db/marketing.js';
const imgUploader = new ImgUploader();
const dbMarketing = new DBMarketing();
export default {
  data() {
    return {
      form: {
        img: '',
        link: '',
        state: true
      },
      fileList: [], // 上传图片的中间过渡图片数据
      loading: false // loading开关控制
    };
  },
  components: {
    SecondMenuLinkContent
  },
  watch: {
    form: {
      handler(newName, oldName) {
        console.log(newName);
      },
      deep: true,
      immediate: true
    },
    'form.img': {
      handler(newName, oldName) {
        console.log(this.form.img);
        if (this.form.img) {
          document.getElementsByClassName('el-upload-list')[0].style.height =
            '90px';
        } else {
          setTimeout(() => {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = '';
          }, 1000);
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeMount() {
    this.getAd();
  },
  methods: {
    // 获取当前页信息
    getAd() {
      dbMarketing.getDBAd().then(res => {
        if (res.success) {
          this.form.img = res.result.adPath;
          this.form.link = res.result.adUrl;
          this.form.state = res.result.isUsed > 0;
          let obj = {};
          obj.url = res.result.adPath;
          if (obj.url) {
            this.fileList.push(obj);
          }
        } else {
          this.$message.error('上传失败！');
        }
      });
    },
    // 删除图片
    onRemove(file, fileList) {
      this.fileList = fileList;
      this.form.img = '';
      this.fileList.map((value, index, Array) => {
        this.form.img = value.url;
      });
    },
    // 上传图片进行判断图片
    beforeUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/bmp' ||
        file.type === 'image/jpg';
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isJPG) {
        this.$message.error('上传图片格式错误!');
        return false;
      } else if (!isLt4M) {
        this.$message.error('上传头像图片大小不能超过 4MB!');
        // this.fileList = this.fileList.splice(1, )
        return false;
      } else {
        this.loading = true;
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then(res => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              this.fileList.push(obj);
              this.loading = false;
              this.form.img = res.imgUrl;
            } else {
              this.loading = false;
              this.$message.error('图片上传超时，请重新上传');
            }
          })
          .catch(res => {
            this.loading = false;
            this.$message.error('图片上传超时，请重新上传');
          });
        return false;
        // console.log(file);
      }
    },
    // 保存
    save() {
      let adUrl = this.form.link;
      let adPath = this.form.img;
      let isUsed = this.form.state ? '1' : '0';
      dbMarketing.postDBAddAd(adUrl, adPath, isUsed).then(res => {
        if (res.success) {
          this.$message.success('保存成功！');
        } else {
          this.$message.error('保存失败！');
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.advertising-popup {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss">
.advertising-popup {
  .advertising-popup-main {
    .el-form {
      .el-form-item {
        margin-bottom: 16px;
        .el-form-item__label {
          line-height: 32px;
          padding-right: 4px;
          font-size: 14px;
          color: rgba(96, 98, 102, 1);
        }
        .el-form-item__content {
          line-height: 32px;
          .el-input__inner {
            width: 320px;
          }
          .el-upload-list {
            display: block;
            .el-upload-list__item {
              height: 90px;
              margin: 0;
              width: auto;
              img {
                height: 100%;
                width: auto;
              }
            }
          }
          .image {
            display: flex;
            overflow: hidden;
            .el-upload--picture-card {
              width: 90px;
              height: 90px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: rgba(234, 238, 245, 0.2);
              border-radius: 8px;
              border: 1px solid rgba(234, 238, 245, 1);
              .el-button {
                width: 90px;
                height: 90px;
                background: rgba(234, 238, 245, 0.2);
                border-radius: 8px;
                border: 0;
              }
              .add {
                width: 24px;
                height: 24px;
                line-height: 24px;
                font-size: 24px;
                text-align: center;
                color: #3d74f2;
                border: 2px solid #3d74f2;
                border-radius: 50%;
              }
            }
          }
          .btn-blue {
            width: 92px;
            letter-spacing: 1px;
          }
        }
      }
      .visible {
        .el-form-item__content {
          .image {
            .el-upload--picture-card {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
